








import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import Bill from "../../models/bill/Bill";

@Component({
	components: {AsiCardDetailEntry, AsiCardDetail}
})
export default class BillCardSettings extends Vue {

	@Prop({type: Object, default: null})
	public bill!: Bill | null;

	private icons = Icon;

}
